import Cookies from 'js-cookie';

// App
const sidebarStatusKey = 'omc_sidebar_status';
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus);

// User
const tokenKey = 'omc_access_token';
export const getToken = () => Cookies.get(tokenKey);
export const setToken = (token: string) => Cookies.set(tokenKey, token);
export const removeToken = () => Cookies.remove(tokenKey);

const brandKey = 'omc_active_branc';
export const getBrand = () => Cookies.get(brandKey);
export const setBrand = (activeBrand: string) => Cookies.set(brandKey, activeBrand);
export const removeBrand = () => Cookies.remove(brandKey);

const roleKey = 'omc_access_role';
export const getRoleToken = () => Cookies.get(roleKey);
export const setRoleToken = (token: string) => Cookies.set(roleKey, token);
export const removeRoleToken = () => Cookies.remove(roleKey);
